export enum FeatureFlags {
  ALLOW_SIGNUP = 'allow_signup',
  TIP_CALCULATOR = 'tip_calculator',
  TIP_CALCULATOR_DAY_PAID = 'tip_calculator_day_paid',
  TIP_CALCULATOR_DEFAULT_POOL = 'tip_calculator_default_pool',
  TIP_CALCULATOR_AI_RULES_SUGGEST = 'tip_calculator_ai_rules_suggest',
  AI_DAY_SEGMENTS_SUGGEST = 'ai_day_segments_suggest',
}

interface IFeatureFlag {
  enabled: boolean;
}

export interface IFeatureFlagsResponse {
  [key: string]: IFeatureFlag;
}
